// ONLY MODIFY THIS FILE BY RUNNING THE FOLLOWING COMMAND:
// php artisan react:enum

export const NotificationIntentType = {
  CustomerConfirmationEmail: {
    Name: 'Customer Confirmation Email',
    Value: 'customer_confirmation_email',
  },
  CustomerCancelledEmail: {
    Name: 'Customer Cancelled Email',
    Value: 'customer_cancelled_email',
  },
  CustomerOrderChangedEmail: {
    Name: 'Customer Order Changed Email',
    Value: 'customer_order_changed_email',
  },
  CustomerDeliveredEmail: {
    Name: 'Customer Delivered Email',
    Value: 'customer_delivered_email',
  },
  CustomerDeliveredText: {
    Name: 'Customer Delivered Text',
    Value: 'customer_delivered_text',
  },
  CustomerOutForDeliveryEmail: {
    Name: 'Customer Out For Delivery Email',
    Value: 'customer_out_for_delivery_email',
  },
  CustomerEmailCampaignEmail: {
    Name: 'Customer Email Campaign Email',
    Value: 'customer_email_campaign_email',
  },
  CustomerMothersDayMarketingEmail: {
    Name: 'Customer Mothers Day Marketing Email',
    Value: 'customer_mothers_day_marketing_email',
  },
  CustomerOccasionReminderEmail: {
    Name: 'Customer Occasion Reminder Email',
    Value: 'customer_occasion_reminder_email',
  },
  CustomerPaymentReceiptEmail: {
    Name: 'Customer Payment Receipt Email',
    Value: 'customer_payment_receipt_email',
  },
  CustomerRefundProcessedEmail: {
    Name: 'Customer Refund Processed Email',
    Value: 'customer_refund_processed_email',
  },
  CustomerFlowerSubscriptionPaymentFailedEmail: {
    Name: 'Customer Flower Subscription Payment Failed Email',
    Value: 'customer_flower_subscription_payment_failed_email',
  },
  CustomerFlowerSubscriptionCancelledEmail: {
    Name: 'Customer Flower Subscription Cancelled Email',
    Value: 'customer_flower_subscription_cancelled_email',
  },
  CustomerFlowerSubscriptionFulfillmentUnavailableEmail: {
    Name: 'Customer Flower Subscription Fulfillment Unavailable Email',
    Value: 'customer_flower_subscription_fulfillment_unavailable_email',
  },
  CustomerFlowerSubscriptionSkippedEmail: {
    Name: 'Customer Flower Subscription Skipped Email',
    Value: 'customer_flower_subscription_skipped_email',
  },
  CustomerFlowerSubscriptionUpcomingOrderEmail: {
    Name: 'Customer Flower Subscription Upcoming Order Email',
    Value: 'customer_flower_subscription_upcoming_order_email',
  },
  CustomerArrangementPhotoEmail: {
    Name: 'Customer Arrangement Photo Email',
    Value: 'customer_arrangement_photo_email',
  },
  CustomerArrangementPhotoText: {
    Name: 'Customer Arrangement Photo Text',
    Value: 'customer_arrangement_photo_text',
  },
  CustomerStatementEmail: {
    Name: 'Customer Statement Email',
    Value: 'customer_statement_email',
  },
  CustomerConfirmationSMS: {
    Name: 'Customer Confirmation S M S',
    Value: 'customer_confirmation_sms',
  },
  CustomerPayLaterConfirmationSMS: {
    Name: 'Customer Pay Later Confirmation S M S',
    Value: 'customer_pay_later_confirmation_sms',
  },
  VendorContactUsMessageEmail: {
    Name: 'Vendor Contact Us Message Email',
    Value: 'vendor_contact_us_message_email',
  },
  VendorContactUsMessageText: {
    Name: 'Vendor Contact Us Message Text',
    Value: 'vendor_contact_us_message_text',
  },
  VendorOrderConfirmationEmail: {
    Name: 'Vendor Order Confirmation Email',
    Value: 'vendor_order_confirmation_email',
  },
  VendorOrderConfirmationMessage: {
    Name: 'Vendor Order Confirmation Message',
    Value: 'vendor_order_confirmation_message',
  },
  VendorFsnIncomingOrderEmail: {
    Name: 'Vendor Fsn Incoming Order Email',
    Value: 'vendor_fsn_incoming_order_email',
  },
  VendorFsnIncomingOrderText: {
    Name: 'Vendor Fsn Incoming Order Text',
    Value: 'vendor_fsn_incoming_order_text',
  },
  VendorFsnIncomingOrderChangedEmail: {
    Name: 'Vendor Fsn Incoming Order Changed Email',
    Value: 'vendor_fsn_incoming_order_changed_email',
  },
  VendorFsnIncomingOrderChangedText: {
    Name: 'Vendor Fsn Incoming Order Changed Text',
    Value: 'vendor_fsn_incoming_order_changed_text',
  },
  VendorCondolencesOrderUpdatedEmail: {
    Name: 'Vendor Condolences Order Updated Email',
    Value: 'vendor_condolences_order_updated_email',
  },
  VendorCondolencesOrderUpdatedText: {
    Name: 'Vendor Condolences Order Updated Text',
    Value: 'vendor_condolences_order_updated_text',
  },
  VendorOrderConfirmationVoice: {
    Name: 'Vendor Order Confirmation Voice',
    Value: 'vendor_order_confirmation_voice',
  },
  VendorOrderConfirmationFax: {
    Name: 'Vendor Order Confirmation Fax',
    Value: 'vendor_order_confirmation_fax',
  },
  VendorPayLaterPaymentReceivedEmail: {
    Name: 'Vendor Pay Later Payment Received Email',
    Value: 'vendor_pay_later_payment_received_email',
  },
  VendorPayLaterPaymentReceivedText: {
    Name: 'Vendor Pay Later Payment Received Text',
    Value: 'vendor_pay_later_payment_received_text',
  },
  VendorStripeTermsUpdateEmail: {
    Name: 'Vendor Stripe Terms Update Email',
    Value: 'vendor_stripe_terms_update_email',
  },
  VendorOverdueOrdersText: {
    Name: 'Vendor Overdue Orders Text',
    Value: 'vendor_overdue_orders_text',
  },
  VendorOverdueOrdersEmail: {
    Name: 'Vendor Overdue Orders Email',
    Value: 'vendor_overdue_orders_email',
  },
  VendorCustomerReviewCreatedText: {
    Name: 'Vendor Customer Review Created Text',
    Value: 'vendor_customer_review_created_text',
  },
  VendorCustomerReviewCreatedEmail: {
    Name: 'Vendor Customer Review Created Email',
    Value: 'vendor_customer_review_created_email',
  },
  CustomerOrderReadyForPickupEmail: {
    Name: 'Customer Order Ready For Pickup Email',
    Value: 'customer_order_ready_for_pickup_email',
  },
  CustomerOrderReadyForPickupText: {
    Name: 'Customer Order Ready For Pickup Text',
    Value: 'customer_order_ready_for_pickup_text',
  },
  CustomerOrderPickedUpEmail: {
    Name: 'Customer Order Picked Up Email',
    Value: 'customer_order_picked_up_email',
  },
  CustomerOrderPickedUpText: {
    Name: 'Customer Order Picked Up Text',
    Value: 'customer_order_picked_up_text',
  },
  CustomerFulfillmentCorrectionEmail: {
    Name: 'Customer Fulfillment Correction Email',
    Value: 'customer_fulfillment_correction_email',
  },
  CustomerFulfillmentCorrectionText: {
    Name: 'Customer Fulfillment Correction Text',
    Value: 'customer_fulfillment_correction_text',
  },
  CustomerReviewInviteText: {
    Name: 'Customer Review Invite Text',
    Value: 'customer_review_invite_text',
  },
  CustomerGoogleReviewInviteText: {
    Name: 'Customer Google Review Invite Text',
    Value: 'customer_google_review_invite_text',
  },
} as const

export type NotificationIntentTypeValue =
  (typeof NotificationIntentType)[keyof typeof NotificationIntentType]['Value']
